import React from 'react';
import LookupText from '../Elements/LookupText';
import LongText from '../Elements/LongText';
import urlHelper from '../Helpers/urlHelper';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import JsxHelper from '../Helpers/JsxHelper';
import ClientInvoiceService from '../Services/ClientInvoiceService';
import datetimeHelper from '../Helpers/datetimeHelper.js';

export default class ClientInvoiceAdminItem {
  constructor(item) {
    if (item === undefined) {
      this.CiId = '';
      this.CiCcid = '';
      this.CiDate = datetimeHelper.toYYYYsMMsDD(new Date());
      this.CiCfid = '';
      this.CiCount = '';
      this.CiTotal = '';
      this.CiStatus = '';
      this.CiYrmo = '';
      this.CiBtid = '';
      this.CiRcyid = '';
      this.CiInvoiceDueDate = datetimeHelper.addDaysToDate(datetimeHelper.toYYYYsMMsDD(new Date()), 45);
      this.CiInternalReferenceNumber = '';
      this.CiApplyVattoFee = '';
      this.CiApplyVattoReimb = '';
      this.CiBillToAddressState = '';
      this.CiBillToAddressLine1 = '';
      this.CiBillToAddressPostalCode = '';
      this.CiBillToAddressLine2 = '';
      this.CiBillToAddressCountry = '';
      this.CiBillToAddressCity = '';
      this.CiBillToContactFirstName = '';
      this.CiBillToContactLastName = '';
      this.CiBillToContactSalutation = '';
      this.CiInterestRate = 2;
      this.CiDaysToPay = 30;
      this.CiFinalizedOn = '';
      this.CiCurrentTotalDue = '';
      this.CiLateFees = '';
      this.CiPaid = '';
      this.CiVat = '';
      this.CiInvoiceNumber = '';
      this.CiVatnumber = '';
      this.CiPonumber = '';
      this.CiInvoiceComment = '';
      this.CiVatpercent = '';
      this.CiStatusCode = '';
      this.CiBillToAddressName = '';
      this.CiBillToClientName = '';
      this.CiDefaultReportName = '';
      this.CiReportGroup1 = '';
      this.CiReportGroup2 = '';
      this.CiReportOrder = '';
      this.CiVersion = '';
      this.CiOfficeId = '';
      this.SapinvoiceNumber = '';
      this.FulfillmentDate = null;
      this.ClientName = '';
      this.ClientNameId = '';
      this.OfficeName = '';
      this.CurrencyCode = '';
      this.FinalizedByUserName = '';
      this.ClientContacts = [];
      this.ServiceFeeId = '';
      this.AsIds = '';
      this.AllItemsInTheSearchAreSelected = '';
      this.SearchParameters = '';
      this.GenerationType = '';
      this.isEditing = false;
      this.Comment = '';
    } else {
      this.CiId = item.ciId;
      this.CiCcid = item.ciCcid;
      this.ClientName = item.clientName;
      this.CiBtid = item.ciBtid;
      this.CiRcyid = item.ciRcyid;
      this.CiDate = item.ciStatusCode && item.ciStatusCode >= 2 ? item.ciDate : new Date();
      this.CiCount = item.ciCount ? item.ciCount : ' ';
      this.CiTotal = item.ciTotal;
      this.CiStatus = item.ciStatus ? item.ciStatus : ' ';
      this.CiYrmo = item.ciYrmo ? item.ciYrmo : ' ';
      this.CiInvoiceDueDate = item.ciInvoiceDueDate;
      this.CiInternalReferenceNumber = item.ciInternalReferenceNumber ? item.ciInternalReferenceNumber : ' ';
      this.CiApplyVattoFee = item.ciApplyVattoFee ? item.ciApplyVattoFee : ' ';
      this.CiApplyVattoReimb = item.ciApplyVattoReimb ? item.ciApplyVattoReimb : ' ';
      this.CiBillToAddressState = item.ciBillToAddressState ? item.ciBillToAddressState : ' ';
      this.CiBillToAddressLine1 = item.ciBillToAddressLine1 ? item.ciBillToAddressLine1 : ' ';
      this.CiBillToAddressPostalCode = item.ciBillToAddressPostalCode ? item.ciBillToAddressPostalCode : ' ';
      this.CiBillToAddressLine2 = item.ciBillToAddressLine2 ? item.ciBillToAddressLine2 : ' ';
      this.CiBillToAddressCountry = item.ciBillToAddressCountry ? item.ciBillToAddressCountry : ' ';
      this.CiBillToAddressCity = item.ciBillToAddressCity ? item.ciBillToAddressCity : ' ';
      this.CiBillToContactFirstName = item.ciBillToContactFirstName ? item.ciBillToContactFirstName : ' ';
      this.CiBillToContactLastName = item.ciBillToContactLastName ? item.ciBillToContactLastName : ' ';
      this.CiBillToContactSalutation = item.ciBillToContactSalutation ? item.ciBillToContactSalutation : ' ';
      this.CiInterestRate = item.ciInterestRate || item.ciInterestRate === 0 ? item.ciInterestRate : ' ';
      this.CiDaysToPay = item.ciDaysToPay ? item.ciDaysToPay : ' ';
      this.CiFinalizedOn = item.ciFinalizedOn;
      this.CiCurrentTotalDue = item.ciCurrentTotalDue ? item.ciCurrentTotalDue : 0;
      this.CiLateFees = item.ciLateFees ? item.ciLateFees : 0;
      this.CiPaid = item.ciPaid;
      this.CiVat = item.ciVat ? item.ciVat : 0;
      this.CiInvoiceNumber = item.ciInvoiceNumber ? item.ciInvoiceNumber : ' ';
      this.CiVatnumber = item.ciVatnumber ? item.ciVatnumber : ' ';
      this.CiPonumber = item.ciPonumber ? item.ciPonumber : ' ';
      this.CiInvoiceComment = item.ciInvoiceComment ? item.ciInvoiceComment : ' ';
      this.CiVatpercent = item.ciVatpercent ? item.ciVatpercent : ' ';
      this.CiStatusCode = item.ciStatusCode ? item.ciStatusCode : ' ';
      this.CiBillToAddressName = item.ciBillToAddressName;
      this.CiBillToClientName = item.ciBillToClientName ? item.ciBillToClientName : ' ';
      this.CiDefaultReportName = item.ciDefaultReportName;
      this.CiReportGroup1 = item.ciReportGroup1;
      this.CiReportGroup2 = item.ciReportGroup2;
      this.CiReportOrder = item.ciReportOrder;
      this.CiVersion = item.ciVersion ? item.ciVersion : 0;
      this.CiOfficeId = item.ciOfficeId ? item.ciOfficeId : ' ';
      this.SapinvoiceNumber = item.sapinvoiceNumber ? item.sapinvoiceNumber : ' ';
      this.FulfillmentDate = item.fulfillmentDate;
      this.ClientName = item.clientName ? item.clientName : ' ';
      this.ClientNameId = item.clientNameId;
      this.OfficeName = item.officeName;
      this.CurrencyCode = item.currencyCode;
      this.FinalizedByUserName = item.finalizedByUserName;
    }
    this.Selected = false;
  }

  static MoneyFields = ['CiTotal', 'CiPaid', 'CiCurrentTotalDue', 'CiVat', 'CiLateFees'];
  static DateFields = ['CiInvoiceDueDate', 'CiDate', 'CiFinalizedOn', 'FulfillmentDate'];

  static Currency() {
    return 'CurrencyCode';
  }
  static MoneyFieldsSecondary = ['CiCurrentTotalDue', 'CiVat', 'CiLateFees'];
  static CurrencySecondary() {
    return 'CurrencyCode';
  }

  static nameOfTheItemDetailList() {
    return 'Client Invoice';
  }

  static serviceFunctionForListTable = (item) => ClientInvoiceService.GetByInvoiceId(item.CiId);

  static FieldsToShowInListTable = [
    {
      data: [
        { name: '-message-', label: 'General Information', className: 'text-left' },
        { label: 'Client', name: 'ClientName', className: 'text-left' },
        {
          label: 'Invoiced On',
          name: (item) => (item.CiDate ? datetimeHelper.toYYYYsMMsDDsHHsMM(item.CiDate, '/') : ''),
          className: 'text-left',
        },
        {
          label: 'Status',
          name: (item) => (
            <LookupText
              lookupId={43}
              value={item.CiStatusCode}
            />
          ),
          className: 'text-left',
        },
        {
          label: 'Bill To Contact',
          name: (item) => `${item.CiBillToContactFirstName} ${item.CiBillToContactLastName}`,
          className: 'text-left',
        },
        {
          label: 'Due On',
          name: (item) => (item.CiInvoiceDueDate ? datetimeHelper.toYYYYsMMsDDsHHsMM(item.CiInvoiceDueDate, '/') : ''),
          className: 'text-left',
        },
        {
          label: 'Finalized By',
          name: (item) => (item.FinalizedByUserName ? item.FinalizedByUserName : ''),
          className: 'text-left',
        },
        { label: 'Office', name: 'OfficeName', className: 'text-left' },
        { label: 'Days To Pay', name: 'CiDaysToPay', className: 'text-left' },
        {
          label: 'Finalized On',
          name: (item) => (item.CiFinalizedOn ? datetimeHelper.toYYYYsMMsDDsHHsMM(item.CiFinalizedOn, '/') : ''),
          className: 'text-left',
        },
        { label: 'Version', name: 'CiVersion', className: 'text-left' },
        { label: 'Late Fee %', name: 'CiInterestRate', className: 'text-left' },
        { label: 'Revenue Period', name: 'CiYrmo', className: 'text-left' },
        {
          label: 'Fulfillment Date',
          name: (item) => (item.FulfillmentDate ? datetimeHelper.toYYYYsMMsDDsHHsMM(item.FulfillmentDate, '/') : ''),
          className: 'text-left',
          condition: { field: 'OfficeName', value: 'BARE Hungary' },
        },

        { name: '-message-', label: 'Invoice Details', className: 'text-left' },
        { label: 'Bare Invoice #', name: 'CiId', className: 'text-left' },
        { label: 'Purchase Order #', name: 'CiPonumber', className: 'text-left' },
        {
          label: 'Form Order',
          name: (item) => ClientInvoiceAdminItem.GetGetFormOrderLabel(item.CiReportOrder),
          className: 'text-left',
        },
        { label: 'Client Invoice #', name: 'CiInvoiceNumber', className: 'text-left' },
        { label: 'Internal Reference #', name: 'CiInternalReferenceNumber', className: 'text-left' },
        {
          label: 'Form Group 1',
          name: (item) => ClientInvoiceAdminItem.GetFormGroupLabel(item.CiReportGroup1),
          className: 'text-left',
        },
        { label: 'SAP Invoice #', name: 'SapinvoiceNumber', className: 'text-left' },
        {
          label: 'Invoice Form',
          name: (item) => ClientInvoiceAdminItem.GetInvoiceFormLabel(item.CiDefaultReportName),
          className: 'text-left',
        },
        {
          label: 'Form Group 2',
          name: (item) => ClientInvoiceAdminItem.GetFormGroupLabel(item.CiReportGroup2),
          className: 'text-left',
        },
        {
          label: 'Invoice Comments',
          name: 'CiInvoiceComment',
          width: TabListTableCellWidthEnum.TwoLines,
          className: 'text-left',
        },

        { name: '-message-', label: 'Billing Details', className: 'text-left' },
        { label: 'Bill To Client Tax #', name: 'CiVatnumber', className: 'text-left' },
        { label: 'First Name', name: 'CiBillToContactFirstName', className: 'text-left' },
        { label: 'Salutation', name: 'CiBillToContactSalutation', className: 'text-left' },
        { label: 'Bill To Client Name', name: 'CiBillToClientName', className: 'text-left' },
        { label: 'Last Name', name: 'CiBillToContactLastName', className: 'text-left' },
        { label: '', name: '', className: 'text-left' },
        {
          label: 'Address',
          name: (item) => `${item.CiBillToAddressLine1}, ${item.CiBillToAddressLine2}`,
          className: 'text-left',
        },
        { label: 'City', name: 'CiBillToAddressCity', className: 'text-left' },
        { label: 'Postal Code', name: 'CiBillToAddressPostalCode', className: 'text-left' },
        { label: 'State', name: 'CiBillToAddressState', className: 'text-left' },
        { label: 'Country', name: 'CiBillToAddressCountry', className: 'text-left' },

        { name: '-message-', label: 'Billing Total', className: 'text-left' },
        { label: 'Currency', name: 'CurrencyCode', className: 'text-left' },
        { label: 'Amount Due', name: 'CiCurrentTotalDue', className: 'text-left' },
        { label: 'Tax', name: 'CiVat', className: 'text-left' },
        { label: 'Late Fees', name: 'CiLateFees', className: 'text-left' },

        { name: '-message-', label: 'Legacy Tax Details', className: 'text-left' },
        { label: 'Tax %', name: 'CiVatpercent', className: 'text-left' },
        {
          label: 'Apply Tax To Client Fee',
          name: (item) => JsxHelper.YesNoEmpty(item.CiApplyVattoFee, true, false),
          className: 'text-left',
        },
        {
          label: 'Apply Tax To Reimbursements',
          name: (item) => JsxHelper.YesNoEmpty(item.CiApplyVattoReimb, true, false),
          className: 'text-left',
        },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: ClientInvoiceAdminItem.getSelectedCellHeader,
        orderById: '',
        data: ClientInvoiceAdminItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      { label: 'Bare Invoice #', orderById: 'CiId', data: ClientInvoiceAdminItem.GetDetailCellContent, minWidth: 20 },
      {
        label: 'Client Name (Caspian Client ID)',
        orderById: 'ClientName',
        data: ClientInvoiceAdminItem.getClientNameCellContent,
        minWidth: 50,
      },
      {
        label: 'Bill To Contact',
        orderById: 'CiBillToContact',
        data: ClientInvoiceAdminItem.getBillToContactCellContent,
        minWidth: 40,
      },
      { label: 'Office', orderById: 'OfficeName', data: 'OfficeName', minWidth: 25 },
      { label: 'PO #', orderById: 'CiPonumber', data: ClientInvoiceAdminItem.getCPoNumberCellContent, minWidth: 20 },
      { label: 'Client Invoice #', orderById: 'CiInvoiceNumber', data: 'CiInvoiceNumber', minWidth: 20 },
      {
        label: 'Internal Reference',
        orderById: 'CiInternalReferenceNumber',
        data: ClientInvoiceAdminItem.getInternalReferenceCellContent,
        minWidth: 30,
      },
      { label: 'Invoiced On', orderById: 'CiDate', data: 'CiDate', minWidth: 20 },
      { label: 'Due Date', orderById: 'CiInvoiceDueDate', data: 'CiInvoiceDueDate', minWidth: 20 },
      {
        label: 'Status',
        orderById: 'CiStatusCode',
        data: (item) => (
          <LookupText
            lookupId={43}
            value={item.CiStatusCode}
          />
        ),
        minWidth: 20,
      },
      { label: 'Invoice Line #', orderById: 'CiCount', data: 'CiCount', minWidth: 10 },
      { label: 'Total', orderById: 'CiTotal', data: 'CiTotal', minWidth: 20 },
      { label: 'Applied Amount', orderById: 'CiPaid', data: 'CiPaid', minWidth: 20 },
      { label: 'Current Due', orderById: 'CiCurrentTotalDue', data: 'CiCurrentTotalDue', minWidth: 20 },
      { label: 'YRMO', orderById: 'CiYrmo', data: 'CiYrmo', minWidth: 10 },
      {
        label: ' ',
        orderById: '',
        data: ClientInvoiceAdminItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static getInternalReferenceCellContent(item) {
    return (
      <LongText
        text={item.CiInternalReferenceNumber ? item.CiInternalReferenceNumber : ' '}
        maxLength={25}
      />
    );
  }

  static getBillToContactCellContent(item) {
    return (
      <LongText
        text={`${item.CiBillToContactFirstName} ${item.CiBillToContactLastName}`}
        maxLength={30}
      />
    );
  }

  static getClientNameCellContent(item) {
    return (
      <LongText
        text={item.ClientNameId ? item.ClientNameId : ' '}
        maxLength={40}
      />
    );
  }

  static getCPoNumberCellContent(item) {
    return (
      <LongText
        text={item.CiPonumber ? item.CiPonumber : ' '}
        maxLength={15}
      />
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Edit',
            iconName: 'fa-solid fa-edit',
            roleKey: 'edit_invoice',
            onClick: () => ClientInvoiceAdminItem.editFunction(item.CiId, item),
            disabled: !item.CiStatusCode,
          },
          {
            text: 'Cancel Invoice',
            iconName: 'fa-solid fa-file-circle-xmark',
            roleKey: 'cancel_invoice',
            onClick: () => ClientInvoiceAdminItem.cancelFunction(item.CiId, item),
            disabled: !item.CiStatusCode || item.CiStatusCode !== 1,
          },
          {
            text: 'Finalize Invoice',
            iconName: 'fa-solid fa-check',
            roleKey: 'finalize_invoice',
            onClick: () => ClientInvoiceAdminItem.finalizeFunction(item.CiId, item),
            disabled: item.CiTotal < 0 || item.CiStatusCode !== 1,
          },
          {
            text: 'Copy Invoice',
            iconName: 'fa-regular fa-copy',
            roleKey: 'clientInvoice_Create',
            onClick: () => ClientInvoiceAdminItem.copyFunction(item.CiId, item),
            disabled: !item.CiStatusCode,
          },
          {
            text: 'Create Credit Memo',
            iconName: 'fa-solid fa-credit-card',
            roleKey: 'create_creditmemo',
            onClick: () => ClientInvoiceAdminItem.createCreditMemoFunction(item.CiId, item),
            disabled: item.CiCurrentTotalDue <= 0 || item.CiStatusCode !== 2,
          },
          {
            iconName: 'fa-solid fa-credit-card',
            roleKey: `creditmemorequest_link`,
            text: 'Credit Memo Requests',
            url: `/creditmemo/search?ClientInvoiceId=${item.CiId}&tab=${1}`,
            title: 'Credit Memo Requests',
            disabled: false,
          },
          {
            iconName: 'fa-solid fa-credit-card',
            roleKey: `creditmemo_link`,
            text: 'Credit Memos',
            url: `/creditmemo/search?ClientInvoiceId=${item.CiId}&tab=${0}`,
            title: 'Credit Memos',
            disabled: false,
          },
        ]}
      />
    );
  }

  static editFunction(id, item) {
    alert('Empty function!');
  }
  static cancelFunction(id, item) {
    alert('Empty function!');
  }
  static finalizeFunction(id, item) {
    alert('Empty function!');
  }
  static copyFunction(id, item) {
    alert('Empty function!');
  }
  static createCreditMemoFunction(id, item) {
    alert('Empty function!');
  }

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.CiId,
      '',
      '',
      'clientinvoicedetails',
      `id=${item.CiId}`,
      'Open up in a new tab'
    );
  }

  static GetInvoiceFormLabel(invoiceForm) {
    if (!invoiceForm) return '';
    return ClientInvoiceAdminItem.InvoiceForms.find((i) => i.value === invoiceForm).label;
  }

  static GetFormGroupLabel(formGroup) {
    if (!formGroup) return '';
    return ClientInvoiceAdminItem.FormGroups.find((i) => i.value === formGroup).label;
  }

  static GetGetFormOrderLabel(formOrder) {
    if (!formOrder) return '';
    return ClientInvoiceAdminItem.FormOrders.find((i) => i.value === formOrder).label;
  }

  static InvoiceForms = [
    { value: 'Client Invoice Detail', label: 'Detailed US' },
    { value: 'Client Invoice Detail Intl', label: 'Detailed Belgium' },
    { value: 'Client Invoice Detail Brazil', label: 'Detailed Brazil' },
    { value: 'Client Invoice Detail China Chinese', label: 'Detailed China Mandarin' },
    { value: 'Client Invoice Detail China English', label: 'Detailed China English' },
    { value: 'Client Invoice Detail India', label: 'Detailed India' },
    { value: 'Client Invoice Detail Singapore', label: 'Detailed Singapore (multi currency)' },
    { value: 'Client Invoice Detail Singapore single currency', label: 'Detailed Singapore (single currency)' },
    { value: 'Client Invoice Summary', label: 'Summary US' },
    { value: 'Client Invoice Summary Intl', label: 'Summary Belgium' },
    { value: 'Client Invoice Summary Brazil', label: 'Summary Brazil' },
    { value: 'Client Invoice Summary China Chinese', label: 'Summary China Mandarin' },
    { value: 'Client Invoice Summary China English', label: 'Summary China English' },
    { value: 'Client Invoice Summary India', label: 'Summary India' },
  ];

  static FormOrders = [
    { value: 'EvalDate', label: 'Assignment Date' },
    { value: 'UnitName', label: 'Location Name' },
    { value: 'UnitId', label: 'Apollo Location ID' },
  ];

  static FormGroups = [
    { value: 'Ad-Hoc', label: 'Ad-Hoc' },
    { value: 'Fee Reason', label: 'Fee Reason' },
    { value: 'Location', label: 'Location Name' },
    { value: 'Country', label: 'Country' },
    { value: 'Project', label: 'Project' },
    { value: 'Location Group', label: 'Location Group' },
    { value: 'Evaluation Date', label: 'Evaluation Date' },
    { value: 'Level2', label: 'Location Level 2' },
    { value: 'Level3', label: 'Location Level 3' },
    { value: 'Level4', label: 'Location Level 4' },
    { value: 'Level5', label: 'Location Level 5' },
    { value: 'Wave', label: 'Assignment Wave' },
  ];

  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          ClientInvoiceAdminItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={ClientInvoiceAdminItem.selectedStatus()}
        onChange={(e) => {
          ClientInvoiceAdminItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }
}
